<div class="batch-analysis-layout">
  <div class="main-content">
    <h3 i18n>Batch Analysis for {{ batch().poName }}</h3>
    <table class="charts-table">
      <tr class="chart-row-top">
        <td class="chart-cell">
          <div class="chart-box">
            <h4 i18n>Measured LAB</h4>
            <app-batch-measured-3d-plot
              [batch]="batch()"
              [model]="model()"
              [axisSpans]="sharedAxisSpans()"
              (scanSelected)="onScanSelected($event)"
            ></app-batch-measured-3d-plot>
          </div>
        </td>
        <td class="chart-cell">
          <div class="chart-box">
            <h4 i18n>Predicted LAB</h4>
            <!-- Replaced by tabbed wrapper: AB (2-D) + L.A.B (3-D) tabs -->
            <app-batch-predicted-plots
              [batch]="batch()"
              (scanSelected)="onScanSelected($event)"
            ></app-batch-predicted-plots>
          </div>
        </td>
      </tr>
      <tr class="chart-row-bottom">
        <td class="chart-cell">
          <div class="chart-box">
            <h4 i18n>Measured Data</h4>
            <app-batch-data-table [batch]="batch()" type="measured" [model]="model()"></app-batch-data-table>
          </div>
        </td>
        <td class="chart-cell">
          <div class="chart-box">
            <h4 i18n>Predicted Data</h4>
            <app-batch-data-table [batch]="batch()" type="predicted" [model]="model()"></app-batch-data-table>
          </div>
        </td>
      </tr>
      <tr>
        <td class="chart-cell" colspan="2">
          <app-batch-summary-stats
            [batch]="batch()"
            (scanSelected)="onSummaryScanClick($event)"
          ></app-batch-summary-stats>
        </td>
      </tr>
      <tr>
        <td class="chart-cell" colspan="2">
          <div class="chart-box">
            <h4 i18n>Radar Analysis</h4>
            <app-batch-radar-plot [batch]="batch()" [model]="model()"></app-batch-radar-plot>
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div class="sidebar">
    <app-batch-scan-details [scan]="selectedScan()" [batch]="batch()"></app-batch-scan-details>
  </div>
</div>
